import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Popover, Typography } from '@mui/material';

export interface PopoverMsgProps {
  anchorEl: HTMLElement | null;
  msg?: string;
}
const PopoverMsg: React.FC<PopoverMsgProps> = ({
  anchorEl,
  msg = 'Copied!',
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Typography sx={{ p: 2 }} variant={'body2'}>
          {t(msg)}
        </Typography>
      </Popover>
    </>
  );
};

export default PopoverMsg;
